import { DialogTitle, DialogActions, Button, Alert, Tab, Tabs } from "@mui/material";
import { ILoginProps } from "./ILoginProps"
import { useState } from "react";
import LoginTab from "./LoginTab"
import CreateUserTab from "./CreateUserTab"

import PortAccount from "../../models/PortAccount";
import { useSnackbar } from "../../libs/dialog/SnackbarProvider";

const TITLES = ["Login with an E-mail", "Create an Account"]


function useLoginProps() : ILoginProps {
    const [email,setEmail] = useState<string>("")
    const [password,setPassword] = useState<string>("")
    const [name,setName] = useState<string>("")
    return {email,setEmail,password,setPassword,name,setName}
}

function loginWithEmail(email:string, password:string) { return PortAccount.i.loginEmail(email, password) }
function createUser(email:string, password:string, name:string) { return PortAccount.i.createUser(email, password, name) }

export default function LoginDialog(props:{onLoggedIn:Function}){
    const loginProps = useLoginProps()
    const [tab,setTab] = useState<number>(0)
    const {setSnackbar} = useSnackbar()

    const onLogin = async () => {
        try {
            if (tab==0) await loginWithEmail(loginProps.email, loginProps.password)
            else await createUser(loginProps.email, loginProps.password, loginProps.name)
            props.onLoggedIn()
        }catch(e:any){
            setSnackbar(e)
        }
    }
    const onTab = (e:any,tab:number) => { setTab(tab) }
    return <>
        <DialogTitle>{TITLES[tab]}</DialogTitle>
        <Tabs value={tab} onChange={onTab}>
            <Tab label="E-mail" id="email"/>
            <Tab label="New User" id="new"/>
        </Tabs>
        <LoginTab {...loginProps} onSubmit={onLogin} tab={tab}/>
        <CreateUserTab {...loginProps} onSubmit={onLogin} tab={tab}/>
        <DialogActions>
            <Button onClick={onLogin}>{tab==0?"Login":"Create"}</Button>
        </DialogActions>
    </>
}
